//client/src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import RootLayout from './Layouts/Rootlayout';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import RequireRole from './Components/RequireRole';

// Import pages
import About from './pages/About';
import MassageTherapy from './pages/MassageTherapy';
import SpaFAQPage from './pages/SpaFAQPage';
import TermsofService from './pages/TermsofService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminDashboard from './pages/admin/AdminDashboard';
import LoginPage from './pages/auth/LoginPage';
import SignupPage from './pages/auth/SignupPage';
import TherapistDashboard from './pages/therapist/TherapistDashboard';
import VenueDashboard from './pages/venue/VenueDashboard';
import ClientDashboard from './pages/client/ClientDashboard';
import BookMassagePage from './pages/marketplace/BookMassagePage';
import MarketplaceConfirmPage from './pages/marketplace/MarketplaceConfirmPage';
import WalletFundingConfirmPage from './pages/WalletFundingConfirmPage';


// Import components
import ScrollToTop from './Components/ScrollToTop';
import Home from './Components/Home';

const App = () => {
  return (
    <HelmetProvider>
    <ToastProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop /> {/* to scroll to top when navigating between pages */}
        <div className="min-h-screen bg-primary-lighter">
          <Routes>
            {/* Admin routes without navbar/footer */}
            <Route path="/admin/*" element={<AdminDashboard />} />

            {/* Therapist/venue/client dashboards without navbar/footer */}
            <Route path="/therapist" element={<RequireRole role="therapist"><TherapistDashboard /></RequireRole>} />
            <Route path="/venue" element={<RequireRole role="venue"><VenueDashboard /></RequireRole>} />
            <Route path="/dashboard" element={<RequireRole role="client"><ClientDashboard /></RequireRole>} />

            {/* Other routes with navbar/footer */}
            <Route
              path="/*"
              element={
                <RootLayout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/massage-therapy" element={<MassageTherapy />} />
                    {/* /booking was a legacy checkout flow with no matching/escrow — merged into /book-massage */}
                    <Route path="/booking" element={<Navigate to="/book-massage" replace />} />
                    <Route path="/booking-confirmation-pg" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/faq" element={<SpaFAQPage />} />
                    <Route path="/terms-of-service" element={<TermsofService />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/book-massage" element={<BookMassagePage />} />
                    <Route path="/marketplace-confirmation-pg" element={<MarketplaceConfirmPage />} />
                    <Route path="/my-orders" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/wallet-funding-confirmation" element={<WalletFundingConfirmPage />} />
                    {/* Other routes that need navbar/footer */}
                  </Routes>
                </RootLayout>
              }
            />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
    </ToastProvider>
    </HelmetProvider>
  );
};

export default App;
